import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { reportActions } from '../../../store/reportStore';
import Map from "../../common/mapComponent";
import HistoryLink from '../../common/historyLink';
import BbCollapse from "../../common/BbCollapse";
import CustomTooltip from "../../common/customTooltip";
import SourceLinks from "../SourceLinks";


class NaturalIdentData extends React.Component {
    state = {
        namesHistoryExpanded: false,
        addressHistoryExpanded: false,
        namesHistoryTouched: false,
        addressHistoryTouched: false
    };
    render() {
        const { data } = this.props.sections.find(o => o.id === this.props.sectionId);
        return (data === undefined || data === null ? null : this.renderWithData(data));
    }

    renderWithData(data) {
        const prefix = isNullOrUndefined(data.prefix) ? null : `${data.prefix.trim()} `;
        const suffix = isNullOrUndefined(data.suffix) ? null : ` ${data.suffix}`;
        const fullName = `${prefix}${data.fullName}${suffix}`;

        const otherNames = data.otherNames.filter(x => !x.isHistorical && !x.isPrimary);
        const hasOtherNames = !isNullOrUndefined(otherNames) && otherNames.length > 0;

        const historicalNames = data.otherNames.filter(x => x.isHistorical);
        const hasHistoricalNames = !isNullOrUndefined(historicalNames) && historicalNames.length > 0;

        const historicalAddresses = data.addresses.filter(x => x.isHistorical);
        const hasHistoricalAddresses = !isNullOrUndefined(historicalAddresses) && historicalAddresses.length > 0;

        const currentAddresses = data.addresses.filter(x => !x.isHistorical);
        const hasCurrentAddresses = !isNullOrUndefined(currentAddresses) && currentAddresses.length > 0;
        return (
            <div>
                <table className="table table-report-section key-value">
                    <colgroup>
                        <col width="30%" />
                        <col width="70%" />
                    </colgroup>
                    <tbody>

                        {!isNullOrUndefined(fullName) && <tr>
                            <td><Translate id="Report.NaturalIdentData.FullName" /></td>
                            <td>
                                <div className="qr-flex">
                                    <span className="bold-name">{fullName}</span>
                                </div>
                                {hasHistoricalNames && <div>
                                    <span className="link-functional" onClick={this.toggleNamesHistory}>
                                        <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched)} noWrapper />
                                    </span>
                                    <BbCollapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched)}>
                                        {historicalNames.map((n, i) =>
                                            <div key={`names-hist-${i}`}>
                                                <div className="qr-flex">
                                                    <span>{n.name}</span>
                                                </div>
                                                <div className="small italic-text">
                                                    <span>(
                                                {this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{n.startFormated}
                                                        {", "}
                                                        {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{n.endFormated}
                                                )</span>
                                                </div>
                                            </div>
                                        )}
                                    </BbCollapse>
                                </div>}
                            </td>
                        </tr>}

                        {hasOtherNames &&
                            <tr>
                                <td style={{ verticalAlign: "top" }}><Translate id="Report.NaturalIdentData.OtherNames" /></td>
                                <td>
                                    {otherNames.map((on, i) =>
                                        <div key={`oth-name-${i}`}>
                                            <span>{on.name}</span>
                                            <div className="small italic-text">
                                                <span>(
                                                {this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{on.startFormated}
                                                    {on.end && <>
                                                        ", "
                                                    {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{on.endFormated}
                                                    </>}
                                            )</span>
                                            </div>
                                        </div>
                                    )}
                                </td>
                            </tr>
                        }

                        {!isNullOrUndefined(data.dobFormated) && <tr>
                            <td><Translate id="Report.NaturalIdentData.DateOfBirth" /></td>
                            <td>{data.dobFormated}</td>
                        </tr>}

                        <tr>
                            <td style={{ verticalAlign: "top" }}><Translate id="Report.Quick.Company.RegisteredSeat" /></td>
                            <td>
                                {hasCurrentAddresses && <div>
                                    {currentAddresses.map((a, i) =>
                                        <div key={`address-${i}`} >
                                            <div className="qr-flex">
                                                <span>
                                                    {a.fullAddress}&nbsp;
                                                <Map id={`address-map-${i}`} address={a.fullAddress} />                                               
                                                </span>
                                                <span className="src" id={`sourceFullId-${i}`}>
                                                    ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                                    <CustomTooltip textAlign="right" placement='left' id={`sourceFullId-${i}`} text={a.sourceFull} hideIcon delay={{ "show": 0, "hide": 0 }}>
                                                    </CustomTooltip>
                                            </span>
                                            </div>
                                        </div>
                                    )}
                                </div>}
                                {hasHistoricalAddresses && <div>
                                    <span className="link-functional" onClick={this.toggleAddressHistory}>
                                        <HistoryLink historyExpanded={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)} noWrapper />
                                    </span>
                                    <BbCollapse className="qr-history" isOpen={this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched)}>
                                        {historicalAddresses.map((a, i) =>
                                            <div key={`address-hist-${i}`}>
                                                <div className="qr-flex">
                                                    <span>
                                                        {a.fullAddress};
                                                        <Map id={`address-hist-map-${i}`} address={a.fullAddress} />
                                                    </span>
                                                    <span className="src" id={`sourceHistFullId-${i}`}>
                                                        ({this.props.translate("Report.Common.Source").toLowerCase()}:&nbsp;{a.source})
                                                        <CustomTooltip textAlign="right" placement='left' id={`sourceHistFullId-${i}`} text={a.sourceFull} hideIcon delay={{ "show": 0, "hide": 0 }}>
                                                        </CustomTooltip>
                                                    </span>
                                                </div>
                                                <div className="small">
                                                    <span className="italic-text">
                                                        ({this.props.translate("Report.Common.From").toLowerCase()}&nbsp;{a.startFormated}
                                                        {", "}
                                                        {this.props.translate("Report.Common.To").toLowerCase()}&nbsp;{a.endFormated})
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </BbCollapse>
                                </div>}
                            </td>
                        </tr>
                    </tbody>
                </table>
                {<SourceLinks sourceLinks={data.SourceLinks} />} 
            </div>
        )
    }

    toggleNamesHistory = () => {
        this.setState({
            namesHistoryExpanded: !this.props.resolveExpanded(this.state.namesHistoryExpanded, this.state.namesHistoryTouched),
            namesHistoryTouched: true
        });
    }

    toggleAddressHistory = () => {
        this.setState({
            addressHistoryExpanded: !this.props.resolveExpanded(this.state.addressHistoryExpanded, this.state.addressHistoryTouched),
            addressHistoryTouched: true
        });
    }
}

export default withLocalize(withRouter(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(NaturalIdentData)));
